"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var handleFormRecipientHiddenField = function (form) {
    var recipient = form.querySelector('.Form__hiddenRecipient');
    var advisee = form.querySelector('.Form__hiddenAdvisor');
    var formEl = form.querySelector('form');
    if (!recipient || !formEl || !advisee) {
        return false;
    }
    formEl.appendChild(recipient);
    formEl.appendChild(advisee);
};
exports.default = (function () {
    var forms = Array.from(document.querySelectorAll('.LPForm__body'));
    forms.forEach(handleFormRecipientHiddenField);
});
